import Navbar from "../Navbar/Navbar";
import "./Header.css";
import LearningImg from "../../assets/images/learning-image.png";
import ButtonLink from "../../components/shared/ButtonLink";

const Header = () => {
	return (
		<header className="gandal-container">
			<Navbar />
			<div className="mt-6 sm:flex justify-between items-center">
				<div className="text-slate-900">
					<h1 className="leading-tight text-4xl font-bold mb-4">
						Tous les sujets de
						<span className="text-red-600"> BAC</span> <span>,</span>{" "}
						<span className="text-amber-400">BEPC</span> <span>et</span>{" "}
						<span className="text-green-600">CEP</span> au même endroit.
					</h1>
					<h5 className="">
						Gandal est une plateforme sur la quelle, vous pouvez tous les
						corrigés des anciens sujets d'examens en Guinée.
					</h5>
				</div>
				<div className="">
					<img src={LearningImg} alt="learning" className="" />
				</div>
			</div>
			<div className="gandal-container mt-10 flex flex-col items-center">
				<div className="mt-7">
					<ButtonLink pathname="/sujets" text="Tous les sujets" />
				</div>
			</div>
		</header>
	);
};

export default Header;
